import { useNoSSR } from 'utils/NoSSR'
import { CART_UPSELLS } from '../cartUpsells.registry'
import { CART_UPSELL_IDS } from '../cartUpsells.schemas'

export function CartUpsellProducers() {
  // useCartStore() throws on the server, and the hydration render reads no records (the server snapshot),
  // so a producer mounted then would start an upsell that storage already holds.
  const isClient = useNoSSR()
  if (!isClient) return null
  return CART_UPSELL_IDS.map((id) => {
    const { Producer } = CART_UPSELLS[id]
    return <Producer key={id} />
  })
}
